import { createTypes } from 'reduxsauce'
 
export default createTypes(`
    GET_UPLOAD_DOCS_INITIAL_DATA
    INITIALIZE_REQUIRED_DOCS
    UPDATE_REQUIRED_DOCS_STATE
`, {}) // options - the 2nd parameter is optional